import React from 'react'
import styled from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'

const Container = styled(Box)`
  justify-content: center;
  align-items: center;
  margin-right: 16px !important;
  position: relative;
`

const BaseCircle = styled(Box)<{ $color?: string }>`
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.colors.brandPrimary ?? '#00ffa3'};
  box-shadow: 0px 0px 5px
    ${({ theme }) => theme.colors.brandPrimary ?? '#00ffa3'};
  border-radius: 250px;
  position: absolute;
  left: 0;
`

const Circle = styled(BaseCircle)<{ delay?: number; $color?: string }>`
  background: transparent;
  position: absolute;
  animation: glow 1s infinite ease-in-out;
  animation-delay: ${({ delay }) => delay ?? 0}s;
  box-shadow: none;
  border: 0.5px solid ${({ theme }) => theme.colors.brandPrimary ?? '#00ffa3'};
  transform-origin: center;
  @keyframes glow {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: scale(2.5);
    }
  }
`

const LiveLoaderCircle = () => {
  return (
    <Container>
      <BaseCircle />
      <Circle />
      <Circle delay={0.25} />
      <Circle delay={0.5} />
    </Container>
  )
}

export default LiveLoaderCircle
